const cards = [
  {
    title: '深度起底某顶流男星背后的资本运作与资源网络',
    desc: '从选秀出道到影视综全面开花，这条成名路背后藏着多少不为人知的资本推手？本文独家分析其背后的经纪公司、投资方和资源交换网络。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20network%20visualization%20in%20warm%20crimson%20and%20dark%20tones%2C%20interconnected%20nodes%20representing%20power%20structures%2C%20editorial%20art%2C%20no%20text%20no%20people&width=700&height=480&seq=cd01-51-012&orientation=landscape',
    tag: '深度扒皮',
    time: '3小时前',
    hot: true,
  },
  {
    title: '综艺选秀背后的残酷真相：练习生被剥削的日与夜',
    desc: '光鲜亮丽的舞台背后，练习生们面临的是超长训练时间、苛刻饮食管控和微薄收入。多位前练习生匿名讲述选秀工业的真实生态。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20stage%20lighting%20effect%20in%20warm%20red%20and%20shadow%2C%20contrast%20between%20light%20and%20dark%2C%20editorial%20composition%2C%20no%20text%20no%20people&width=700&height=480&seq=cd02-51-013&orientation=landscape',
    tag: '行业揭秘',
    time: '6小时前',
    hot: false,
  },
  {
    title: '网红经济泡沫破裂？三大头部MCN机构内部分析',
    desc: '随着监管趋严和流量成本攀升，曾经风光无限的网红经济正面临前所未有的挑战。本文对比分析三家头部MCN的最新财报和运营策略。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20chart%20aesthetic%20with%20warm%20amber%20and%20dark%20gray%20tones%2C%20declining%20geometric%20shapes%2C%20editorial%20business%20style%2C%20no%20text%20no%20people&width=700&height=480&seq=cd03-51-014&orientation=landscape',
    tag: '产业分析',
    time: '9小时前',
    hot: true,
  },
  {
    title: '从素人到顶流：复盘2024年最成功的"造星"案例',
    desc: '一部剧、一首歌、一个综艺，就能让一个素人一夜爆红。但爆红之后如何维持热度？本文复盘五个典型案例的走红路径与后续运营。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20rising%20geometric%20forms%20in%20warm%20crimson%20and%20gold%2C%20ascending%20trajectory%20concept%2C%20editorial%20artistic%20render%2C%20no%20text%20no%20people&width=700&height=480&seq=cd04-51-015&orientation=landscape',
    tag: '星路追踪',
    time: '12小时前',
    hot: false,
  },
  {
    title: '娱乐圈塌房年终盘点：2024年那些轰然倒塌的人设',
    desc: '从"好男人"到"劈腿惯犯"，从"清纯玉女"到"翻车大王"，这一年娱乐圈的人设崩塌比以往任何时候都更加密集和震撼。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20crumbling%20geometric%20structures%20in%20warm%20red%20and%20dark%20tones%2C%20collapsing%20forms%2C%20dramatic%20editorial%20composition%2C%20no%20text%20no%20people&width=700&height=480&seq=cd05-51-016&orientation=landscape',
    tag: '年度盘点',
    time: '1天前',
    hot: true,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">深度爆料</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article
              key={card.title}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 group cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
                {card.hot && (
                  <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-bold whitespace-nowrap flex items-center gap-1">
                    <i className="ri-fire-line"></i> HOT
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400 pt-3 border-t border-background-200/70">
                  <span>{card.time}</span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}